import { useModal, MODAL_TYPES } from '@/components/modal/ModalProvider';

/**
 * Wires up the optional "Learn More" modal shared by the column selectors.
 *
 * Derives everything from `settings` alone so it can be called before the
 * selectors run their input validation.
 *
 * @returns { hasModal, linkLabel, linkPosition, show } — pass the whole object
 *   to <ColumnSelectorHeader /> and <HelpModalLink />.
 */
export function useVariantHelpModal(settings) {
  const { showModal } = useModal();

  const columnSettings = settings?.modular_blocks?.[0]?.column;
  const bodyCopy = settings?.modal?.modal_content;

  function show(e) {
    e.preventDefault();
    showModal(MODAL_TYPES.variantHelp, {
      modalSettings: {
        bodyCopy,
        heading: settings?.modal?.modal_heading,
        images: columnSettings?.modal?.featured_image
      }
    });
  }

  return {
    hasModal: !!bodyCopy,
    linkLabel: settings?.modal?.link_copy ?? 'Learn More',
    linkPosition: columnSettings?.modal?.link_position ?? 'Top Right',
    show
  };
}
